export default __webpack_public_path__ + "static/media/DJI_0519.24951493.jpg";